<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      :title="title"
      center
      width="746px"
      :before-close="$onClose"
      destroy-on-close
    >
      <div style="margin: 30px 100px 30px 20px; background-color: transparent">
        <div>
          <h4 class="must-mark title">深造状态</h4>
          <el-select
            v-model="education_status"
            placeholder="请选择"
            @change="changeSelectJob"
          >
            <el-option
              v-for="item in eduStatusOptions"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div
          v-if="
            education_status != '其他' &&
              education_status != '重读本科' &&
              education_status != '第二学士学位'
          "
        >
          <h4 class="title">所在地</h4>
          <el-cascader
            class="input input_daterange"
            v-model="location"
            :options="regionOptions"
            :props="{ expandTrigger: 'hover' }"
            @change="handleRegionChange"
          ></el-cascader>
        </div>
        <div
          v-if="
            education_status != '其他' &&
              education_status != '重读本科' &&
              education_status != '第二学士学位'
          "
        >
          <h4 class="must-mark title">
            院校名称
          </h4>
          <el-input v-model="education_school" placeholder="请输入"></el-input>
        </div>
        <div v-if="education_status != '其他'">
          <h4 class="title">院校专业</h4>
          <el-input
            v-model="education_programme"
            placeholder="请输入"
          ></el-input>
          <!-- <el-select v-model="education_programme" placeholder="请选择">
            <el-option
              v-for="item in programmeOptions"
              :key="item"
              :value="item"
            ></el-option>
          </el-select> -->
        </div>
        <div
          v-if="
            education_status != '其他' &&
              education_status != '重读本科' &&
              education_status != '第二学士学位'
          "
        >
          <h4 class="title">毕业年份</h4>
          <el-date-picker
            v-model="education_graduation_year"
            type="year"
            placeholder="选择年"
            value-format="yyyy"
          ></el-date-picker>
        </div>
        <div v-if="education_status == '其他'">
          <h4 class="title">其他</h4>
          <el-input v-model="education_other" placeholder="请输入"></el-input>
        </div>
      </div>

      <div class="footDialog">
        <el-button
          style="width: 106px; float: right"
          size="small"
          type="primary"
          v-preventReClick
          @click="save()"
          >保存</el-button
        >
        <el-button
          style="width: 106px; float: right; margin-right: 15px"
          size="small"
          @click="close()"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as StrUtils from '@/utils/strUtils.js'
import preventReClick from '@/utils//preventReClick' // 防多次点击，重复提交
import * as Constant from '@/utils/constant.js'

var thisIndex
var thisUserName
var thisType
var thisInfo = {}

export default {
  data() {
    return {
      changVisible: false,

      title: '',
      education_status: '',
      location: '',
      education_nation: '',
      education_province: '',
      education_city: '',
      education_school: '',
      education_programme: '',
      education_graduation_year: '',
      education_other: '',
      clickLastTime: 0, // 默认上一次点击时间为0
      eduStatusOptions: Constant.edu_status_options, // 深造状态
      programmeOptions: Constant.programme_options,
      regionOptions: JSON.parse(localStorage.getItem('options_region'))
    }
  },
  created() {},
  methods: {
    $onClose(done) {
      done()
    },
    close() {
      this.changVisible = false
    },
    changeSelectJob(select) {
      this.cleanInput()
    },
    // 地区选择
    handleRegionChange(value) {
      console.log('结果', value)
      this.education_nation = value[0]
      this.education_province = value[1]
      this.education_city = value[2]
    },
    save() {
      let clickNow = new Date().valueOf()
      if (clickNow - this.clickLastTime < 2000) return
      this.clickLastTime = clickNow

      if (thisInfo == undefined) {
        thisInfo = {}
        thisInfo.id = 0
      }
      thisInfo.delete_time = 0
      switch (thisType) {
        case 'ais_education':
          var year = new Date().getFullYear()
          if (StrUtils.isEmpty(this.education_status)) {
            this.$message.error('请选择深造状态')
            return
          } else if (
            this.education_status == '其他' &&
            StrUtils.isEmpty(this.education_other)
          ) {
            this.$message.error('请完善信息')
            return
          } else if (
            (this.education_status == '重读本科' ||
              this.education_status == '第二学士学位') &&
            (StrUtils.isEmpty(this.education_status) ||
              StrUtils.isEmpty(this.education_programme))
          ) {
            this.$message.error('请完善信息')
            return
          } else if (
            (this.education_status == '硕士研究生' ||
              this.education_status == '博士研究生') &&
            StrUtils.isEmpty(this.education_school)
          ) {
            this.$message.error('请填写院校名称')
            return
          }
          thisInfo.education_status = this.education_status
          thisInfo.education_nation = this.education_nation
          thisInfo.education_province = this.education_province
          thisInfo.education_city = this.education_city
          thisInfo.education_school = this.education_school
          thisInfo.education_programme = this.education_programme
          thisInfo.education_graduation_year = this.education_graduation_year
          thisInfo.education_other = this.education_other
          this.location = StrUtils.getEduLocation(thisInfo)
          thisInfo.location = this.location
          break
      }
      this.changVisible = false
      this.$emit('toSave', thisIndex, thisType, thisInfo)
    },
    // 页面初始化时加载的事件
    show(index, userName, type, info) {
      this.cleanInput()
      this.changVisible = true
      thisIndex = index
      thisUserName = userName
      thisType = type
      thisInfo = info
      switch (thisType) {
        case 'ais_education':
          if (thisInfo === undefined) {
            this.title = '新增 ' + thisUserName + ' 深造信息'
          } else {
            this.title = '编辑 ' + thisUserName + ' 深造信息'
            this.editEducation(thisInfo)
          }
          break
      }
    },
    // 清除输入框
    cleanInput() {
      // this.education_status = "";
      this.location = ''
      this.education_nation = ''
      this.education_province = ''
      this.education_city = ''
      this.education_school = ''
      this.education_programme = ''
      this.education_graduation_year = ''
      this.education_other = ''
    },
    // 编辑深造信息
    editEducation(info) {
      this.education_status = info.education_status
      this.location = StrUtils.getEduLocationArray(info)
      this.education_nation = info.education_nation
      this.education_province = info.education_province
      this.education_city = info.education_city
      this.education_school = info.education_school
      this.education_programme = info.education_programme
      this.education_graduation_year = info.education_graduation_year
      this.education_other = info.education_other
    }
  }
}
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/addEditEduDialog.vue